import styles from './StatusCellRenderer.module.css';
import { Box, Text, Tooltip } from '@chakra-ui/react';
import Statuses from '../../utils/statuses';
import { toast } from 'react-toastify';

const UserStatusCellRenderer = ({ value, noCircle, returnedMessage }) => {
    // Remove the [ClientError] prefix if present
    //const formattedMessage = returnedMessage?.replace('[ClientError] : ', '') || returnedMessage;
    const formattedMessage = returnedMessage;
    const content = (
        <Box
            onClick={() => {
                if (formattedMessage) {
                    navigator.clipboard.writeText(formattedMessage);
                    toast.success('Copied to clipboard');
                }
            }}
            cursor={formattedMessage ? 'pointer' : 'default'}
            className={`${styles.tag} ${styles[Statuses[value]?.type + 'Tag']}`}
            sx={{
                display: 'flex',
                alignItems: noCircle ? 'center' : null,
                justifyContent: noCircle ? 'center' : null,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}>
            {!noCircle && (
                <div
                    className={`${styles.circle} ${styles[Statuses[value]?.type + 'Circle']}`}
                />
            )}
            <Text isTruncated>{Statuses[value]?.displayedName}</Text>
        </Box>
    );

    return formattedMessage ? (
        <Tooltip
            hasArrow
            portalProps={{ containerRef: undefined }}
            maxW="400px"
            label={<Text wordBreak="break-all">{formattedMessage}</Text>}
            aria-label="Status tooltip">
            {content}
        </Tooltip>
    ) : (
        content
    );
};

export default UserStatusCellRenderer;
